import Table from './Table';
import Column from './Column';
import ColumnGroup from './ColumnGroup';

Table.Column = Column;
Table.ColumnGroup = ColumnGroup;

export default Table;
export { Column, ColumnGroup };


//////////////////
// WEBPACK FOOTER
// ./~/rc-table/es/index.js
// module id = 1709
// module chunks = 0